<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="handleBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item>
          <v-list-item-title>เพิ่มพนักงานในกลุ่ม</v-list-item-title>
        </v-list-item>
      </v-toolbar>
      <div class="pt-2 px-4" style="height: 100%; overflow: auto">
        <v-row>
          <v-col class="py-0" cols="12" lg="6">
            <label class="caption"> ค้นหา </label>
            <v-text-field
              v-model="search"
              class="fix-google-chrome"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              clearable
              @input="handleSearchTaEmployee"
              hide-details
            >
            </v-text-field
          ></v-col>
          <v-col class="py-0" cols="12" lg="6">
            <label class="caption"> หน่วยงาน </label>
            <v-autocomplete
              v-model="taOrganizationFilter"
              class="fix-google-chrome"
              :items="taOrganizations"
              item-text="title_th"
              item-value="organization_uuid"
              hide-details
              outlined
              dense
              clearable
              @change="handleFilterTaOrganization"
            >
            </v-autocomplete
          ></v-col>
        </v-row>
        <div class="d-lg-flex justify-space-between align-baseline mb-4">
          <div class="ml-4 d-inline-flex align-center">
            <input
              :disabled="pagination.isLoading || !taEmployeesGroupMember.length"
              :indeterminate.prop="indeterminateSelectAll"
              id="selectAll"
              style="width: 18px; height: 18px"
              type="checkbox"
              :checked="checkedSelectAll"
              @input="handleSelectAll"
            />
            <label for="selectAll" class="ml-4" style="font-size: 14px">
              เลือกทั้งหมด
            </label>
          </div>
          <div style="width: 200px">
            <v-select
              style="font-size: 14px"
              v-model="sort"
              :disabled="pagination.isLoading"
              prepend-inner-icon="mdi-sort-ascending"
              :items="sorts"
              hide-details
              @change="handleChangeSort"
            ></v-select>
          </div>
        </div>
        <DynamicScroller
          :items="taEmployeesGroupMember"
          :min-item-size="pagination.limit"
          key-field="employee_uuid"
        >
          <template v-slot="{ item, index, active }">
            <DynamicScrollerItem
              :item="item"
              :active="active"
              :data-index="index"
            >
              <v-card
                color="#f5f5f5"
                outlined
                class="d-flex align-center mb-2"
                v-observe-visibility="
                  item.employee_uuid === lastEmployee.employee_uuid &&
                  !isLastPage
                    ? infiniteScrollHandler
                    : false
                "
              >
                <span class="pa-4">
                  <input
                    :id="item.employee_uuid"
                    :value="item.employee_uuid"
                    v-model="taEmployeesSelected"
                    style="width: 18px; height: 18px"
                    type="checkbox"
                  />
                </span>
                <v-list-item two-line class="px-0">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.firstname_th }} {{ item.lastname_th }} [{{
                        item.employee_code
                      }}]
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ item.organization.title_th }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </DynamicScrollerItem>
          </template>
        </DynamicScroller>
        <div v-if="pagination.isLoading">
          <v-card
            color="#f5f5f5"
            v-for="num in 2"
            :key="num"
            outlined
            class="mb-2 px-4 py-2"
          >
            <Skeleton width="200px" />
            <Skeleton :count="1" />
          </v-card>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row justify="center" align="center">
          <v-btn
            class="primary mr-3"
            :disabled="!isTaEmployeeGroupAddDataChange"
            depressed
            @click="onSubmit"
          >
            เพิ่มพนักงาน
          </v-btn>
          <v-btn depressed @click="handleCancel"> ยกเลิก </v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import _ from 'lodash'
import { Skeleton } from 'vue-loading-skeleton'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
    DynamicScroller,
    DynamicScrollerItem,
    Skeleton,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    taEmployeeGroup: {
      type: Object,
    },
    taEmployeeGroupInit: {
      type: Object,
    },
  },
  watch: {
    formShow(value) {
      if (value) {
        this.taEmployeesGroupMember = []
        this.pagination.currentPage = 1
        this.totalTaEmployeesGroupMember = 0
        this.getTaEmployeesGroupMember()
      }
    },
  },
  data() {
    return {
      taEmployeesSelected: [],
      taOrganizationFilter: '',
      search: '',
      pagination: {
        currentPage: 1,
        limit: 10,
        isLoading: true,
      },
      taEmployeesGroupMember: [],
      totalTaEmployeesGroupMember: 0,
      sort: 'firstname_th,asc',
      sorts: [
        { id: 1, text: 'เรียงตามชื่อ (ก - ฮ)', value: 'firstname_th,asc' },
        {
          id: 2,
          text: 'เรียงตามรหัส',
          value: 'employee_code,asc',
        },
        {
          id: 3,
          text: 'เรียงตามหน่วยงาน',
          value: 'organization_th,asc',
        },
      ],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    checkedSelectAll() {
      return (
        this.taEmployeesSelected.length &&
        this.taEmployeesSelected.length === this.totalTaEmployeesGroupMember
      )
    },
    indeterminateSelectAll() {
      return (
        this.taEmployeesSelected.length &&
        this.taEmployeesSelected.length !== this.totalTaEmployeesGroupMember
      )
    },
    lastEmployee() {
      const [lastItem] = this.taEmployeesGroupMember.slice(-1)
      return lastItem || {}
    },
    isLastPage() {
      return (
        this.pagination.currentPage ===
        Math.ceil(this.totalTaEmployeesGroupMember / this.pagination.limit)
      )
    },
    taOrganizations() {
      return this.$store.state.organization.organizations
    },
    isTaEmployeeGroupAddDataChange() {
      if (this.taEmployeesSelected.length) {
        this.$emit('isTaEmployeeGroupAddDataChange', true)
        return true
      }
      this.$emit('isTaEmployeeGroupAddDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      fetchTaEmployeesGroupMember:
        'taEmployeesGroup/fetchTaEmployeesGroupMember',
      addTaEmployeeGroupMember: 'taEmployeesGroup/addTaEmployeeGroupMember',
      fetchTaEmployeeGroupById: 'taEmployeesGroup/fetchTaEmployeeGroupById',
    }),
    async handleSelectAll(event) {
      try {
        const isChecked = event.target.checked
        if (isChecked) {
          if (
            this.totalTaEmployeesGroupMember ===
            this.taEmployeesGroupMember.length
          ) {
            this.taEmployeesSelected = this.taEmployeesGroupMember.map(
              (e) => e.employee_uuid
            )
          } else {
            this.$store.state.loading = true

            const { company_uuid } = this.$store.state.authentication.company

            const payload = {
              company_uuid,
              employee_group_uuid: this.taEmployeeGroup.employee_group_uuid,
              query: {
                organization_uuid: this.taOrganizationFilter || undefined,
                search: this.search || undefined,
                sort: this.sort,
                is_outside_group: true,
              },
            }

            const { data: taEmployeesGroupMember } =
              await this.fetchTaEmployeesGroupMember(payload)
            this.taEmployeesSelected = taEmployeesGroupMember.map(
              (e) => e.employee_uuid
            )
            this.$store.state.loading = false
          }
        } else {
          this.taEmployeesSelected = []
        }
      } catch (error) {
        this.$store.state.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleFilterTaOrganization() {
      this.taEmployeesSelected = []
      this.taEmployeesGroupMember = []
      this.pagination.currentPage = 1
      this.getTaEmployeesGroupMember()
    },
    handleSearchTaEmployee: _.debounce(function () {
      if (this.search === undefined || this.search === null) return
      this.taEmployeesSelected = []
      this.taEmployeesGroupMember = []
      this.pagination.currentPage = 1
      this.getTaEmployeesGroupMember()
    }, 1000),
    handleChangeSort() {
      this.taEmployeesSelected = []
      this.taEmployeesGroupMember = []
      this.pagination.currentPage = 1
      this.getTaEmployeesGroupMember()
    },
    async getTaEmployeesGroupMember() {
      try {
        this.pagination.isLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          employee_group_uuid: this.taEmployeeGroup.employee_group_uuid,
          query: {
            organization_uuid: this.taOrganizationFilter || undefined,
            search: this.search || undefined,
            sort: this.sort,
            limit: `${this.pagination.limit},${
              (this.pagination.currentPage - 1) * this.pagination.limit
            }`,
            is_outside_group: true,
          },
        }
        const {
          total: totalTaEmployeesGroupMember,
          data: taEmployeesGroupMember,
        } = await this.fetchTaEmployeesGroupMember(payload)
        this.totalTaEmployeesGroupMember = totalTaEmployeesGroupMember
        this.setTaEmployeesGroupMember(taEmployeesGroupMember)
        this.pagination.isLoading = false
      } catch (error) {
        this.pagination.isLoading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async getNextTaEmployeesGroupMember() {
      try {
        this.pagination.currentPage += 1

        await this.getTaEmployeesGroupMember()
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    setTaEmployeesGroupMember(taEmployeesGroupMember) {
      this.taEmployeesGroupMember = [
        ...this.taEmployeesGroupMember,
        ...taEmployeesGroupMember,
      ]
    },
    infiniteScrollHandler(isVisible, entry) {
      if (isVisible && entry.isIntersecting) {
        this.getNextTaEmployeesGroupMember()
      }
    },
    async onSubmit() {
      try {
        this.search = ''
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company
        const employee_group_uuid = this.taEmployeeGroup.employee_group_uuid

        const payload = {
          company_uuid,
          employee_group_uuid,
          body: {
            employee_uuids: this.taEmployeesSelected,
          },
        }

        await this.addTaEmployeeGroupMember(payload)
        const taEmployeeGroup = await this.fetchTaEmployeeGroupById({
          company_uuid,
          employee_group_uuid,
        })
        this.$store.commit(
          'taEmployeesGroup/EDIT_TA_EMPLOYEE_GROUP',
          taEmployeeGroup
        )
        this.taEmployeesSelected = []
        this.$emit('addTaEmployeeGroupMemberSuccess', taEmployeeGroup)
        this.$store.state.loading = false

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'เพิ่มข้อมูลสำเร็จ',
        }

        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        this.$store.state.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleCancel() {
      this.taEmployeesSelected = []
      this.$emit('onClickBlack')
    },
    handleBack() {
      if (this.isTaEmployeeGroupAddDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('onClickBlack')
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
      this.$emit('onClickBlack')
    },
  },
}
</script>
